var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"primary":"","disabled":_vm.isLoading || _vm.isRejected},on:{"click":_vm.exportOrders}},[_vm._v(" "+_vm._s(_vm.isRejected ? _vm.rejectReason : 'Export')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }